import { useIntl } from 'react-intl';
import { Tooltip, TooltipProps } from '@ets/design-system';

import { useSelector } from '_common/hooks';
import { selectIsPageLayout } from 'Editor/redux/EditorStatusSlice';

type PageLayoutTooltipProps = Omit<TooltipProps, 'content'> & {
  content?: string;
  type: 'comment' | 'trackedAction' | 'task' | 'reference' | 'note';
  disabled?: boolean;
};

const PageLayoutTooltip = ({
  content,
  disabled,
  visible = true,
  type,
  ...props
}: PageLayoutTooltipProps) => {
  const intl = useIntl();
  const isPageLayout = useSelector(selectIsPageLayout);

  const getTooltipContent = () => {
    switch (type) {
      case 'comment':
        return 'CANNOT_MAKE_CHANGES_TO_COMMENTS_IN_PAGE_LAYOUT';
      case 'trackedAction':
        return 'CANNOT_MAKE_CHANGES_TO_TRACK_CHANGES_IN_PAGE_LAYOUT';
      case 'task':
        return 'CANNOT_MAKE_CHANGES_TO_TASKS_IN_PAGE_LAYOUT';
      case 'reference':
        return 'CANNOT_MAKE_CHANGES_TO_REFERENCES_IN_PAGE_LAYOUT';
      case 'note':
        return 'CANNOT_MAKE_CHANGES_TO_NOTES_IN_PAGE_LAYOUT';
      default:
        return '';
    }
  };

  return (
    <Tooltip
      {...props}
      visible={disabled ? false : isPageLayout || (visible && !!content)}
      content={isPageLayout ? intl.formatMessage({ id: getTooltipContent() }) : content || ''}
    />
  );
};

export default PageLayoutTooltip;
